var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Centeral place to handle widget errors
var handleError = function (payload) {
    var _a;
    if ((_a = window === null || window === void 0 ? void 0 : window._mensenlinqEvents) === null || _a === void 0 ? void 0 : _a.emit) {
        window._mensenlinqEvents.emit('statistics', {
            type: 'error',
            payload: __assign(__assign({}, payload), { timestamp: Date.now() }),
        });
    }
};
export default handleError;
